import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import cookie from 'js-cookie'
import { atrustCheck } from '@sjzy/library/dist/components/a-trust/atrustCheck'
import config from '@/config'
import { useGlobSetting } from '@/composables/setting/useGlobSetting'

const globSetting = useGlobSetting()
/** 是否需要获取菜单 */
let isHasFetchMenu = true

/** 处理路由页面的权限 */
export async function createPermissionGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const router = useRouter()
  const mode = import.meta.env.MODE
  const { routes, setRoutes } = useRoutesStore()
  const { resetAll } = useUserStore()
  const hasToken = Boolean(cookie.get(`${mode}_${config.tokenTableName}`))
  const isWhiteRoute = config.routesWhiteList.includes(to.path)
  // 检测零信任环境
  const isCheckAtrust
    = import.meta.env.VITE_PROJECT === 'HB' || window.__MICRO_APP_ENVIRONMENT__
      ? true
      : await atrustCheck()
  console.log(hasToken, 'hasToken')
  console.log(isWhiteRoute, 'isWhiteRoute')
  console.log(isHasFetchMenu, 'isHasFetchMenu')
  const routeSwitches: CommonType.StrategicPattern[] = [
    // 检测是否零信任环境
    {
      condition: !isCheckAtrust,
      callback: () => {
        if (to.path === '/aTrust')
          next()
        else next(`/aTrust?replaceUrl=${window.location.pathname}`)
      },
    },
    // 在访问白名单
    {
      condition: isWhiteRoute,
      callback: () => {
        next()
      },
    },
    // 如果没有权限
    {
      condition: !hasToken,
      callback: () => handleToLogin(),
    },
    // 没有菜单 就去获取菜单
    {
      condition: !routes.length,
      callback: async () => {
        try {
          if (isHasFetchMenu) {
            isHasFetchMenu = false
            await setRoutes(config.authentication, next)
            next({ ...to, replace: true })
          }
          else {
            next()
          }
        }
        catch (err) {
          console.error(' 错误拦截:', err)
          await resetAll()
        }
      },
    },
    // 有菜单
    {
      condition: !!routes.length,
      callback: () => {
        // 如果跳转的是无权限，重定向到首页
        if (to.path === '/unapproved') {
          next('/')
        }
        else {
          next()
        }
      },
    },
  ]
  routeSwitches.some(({ condition, callback }) => {
    if (condition)
      callback()

    return condition
  })

  /** 跳转登录 */
  function handleToLogin() {
    cookie.remove(`${mode}_${config.tokenTableName}`, {
      domain: globSetting.loginCookieDomain,
      path: '/',
    })
    if (globSetting.loginUrl) {
      window.location.href = `${globSetting.loginUrl}/login?replaceUrl=${window.origin}/slogin`
    }
    else {
      router.push({
        name: 'Login',
      })
    }
  }
}
